import {Link} from 'react-router-dom';

import sleekArrow from './images/icons/sleekArrow.svg'
import homeIcon from './images/icons/home2.svg'
import { useNavigate } from 'react-router-dom';



export default function ProjectNav ({NextProject, PrevProject}){

    const navigate = useNavigate();

    const handleClick = (direction) => {

        if (direction === 'previous') {
          navigate(PrevProject);
        } else if (direction === 'next') {
          navigate(NextProject);
        } else if (direction === 'home') {
          navigate('/');
        }

      };

    return(
        <div style={{'background-color': '#fafafa', width: '100%', display: 'flex', 'justify-content': 'center',   'margin-bottom': '0px'    }}>
            <div style={{display: 'flex', width: '100%', margin: '0px', 'background-color': '#ffffff'}}>
                
                <div class="nextProj" onClick={() => handleClick('previous')}>
                    <img src={sleekArrow} style={{opacity: '.7'}}/>
                    <div class="nextPText">Previous Project</div>
                </div>
                
                <div class="navHome" onClick={() => handleClick('home')}><img src={homeIcon} style={{ opacity: '.6'}}/></div>
                
                <div class="nextProj" style={{'justify-content':'end'}} onClick={() => handleClick('next')}>
                    <div class="nextPText">Next Project</div>
                    <img src={sleekArrow} style={{transform: 'rotate(180deg) translateY(-2px)', opacity: '.7'}}/>
               
                </div>
            </div>
        </div>
    )
}